import { render, staticRenderFns } from "./SearchCards.vue?vue&type=template&id=6b7220df&scoped=true&"
import script from "./SearchCards.vue?vue&type=script&lang=js&"
export * from "./SearchCards.vue?vue&type=script&lang=js&"
import style0 from "./SearchCards.vue?vue&type=style&index=0&id=6b7220df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7220df",
  null
  
)

export default component.exports